import { render, staticRenderFns } from "./ResumenRecibo.vue?vue&type=template&id=e7ee33bc"
import script from "./ResumenRecibo.vue?vue&type=script&lang=ts"
export * from "./ResumenRecibo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports